import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useState } from 'react'
import { Button } from '@/components/shared/atoms/Button'
import { signOut } from '@/auth/firebase'

export const Route = createFileRoute('/(onboarding)/(auth)/logout')({
    component: LogoutRoute,
})

function LogoutRoute() {
    const navigate = useNavigate()
    const [isLoggingOut, setIsLoggingOut] = useState(false)
    const [error, setError] = useState<string | null>(null)

    const handleLogout = async () => {
        try {
            setIsLoggingOut(true)
            setError(null)
            await signOut()
            // Redirect to home page after successful logout
            navigate({ to: '/onboarding' })
        } catch (err) {
            console.error('Error signing out:', err)
            setError('Failed to sign out. Please try again.')
        } finally {
            setIsLoggingOut(false)
        }
    }

    return (
        <div className="mx-auto flex h-full max-w-md flex-col items-center justify-center bg-white p-4">
            <h1 className="mb-8 text-2xl font-bold">Logout</h1>

            <p className="mb-6 text-center">
                Click the button below to log out of your account.
            </p>

            {error && <p className="mb-4 text-red-600">{error}</p>}

            <Button
                onClick={handleLogout}
                disabled={isLoggingOut}
                className="w-full max-w-xs"
            >
                {isLoggingOut ? 'Logging out...' : 'Log Out'}
            </Button>
        </div>
    )
}
